import {
  AddRounded,
  EastRounded,
  QuestionAnswerOutlined,
  SpeakerNotesOffRounded,
} from "@mui/icons-material";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isEmpty, size } from "lodash";
import PropTypes from "prop-types";
import { Suspense, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import EnhancedCommentItemRenderer from "../../../../../_src_shared/comments/EnhancedCommentItemRenderer";
import Flx from "../../../../../components/layout/Flx";
import LoadingFallback from "../../../../../components/LoadingFallback";
import Txt from "../../../../../components/typography/Txt";
import TitledCard from "../../../../../components/ui/TitledCard";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { sidebarTypeToggle } from "../../../../../redux/actions/sidebarActions";

const SummaryTabCommentsCard = ({ sx, width = "400px" }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const dispatch = useDispatch();

  const comments = useMemo(
    () => loanDrilldown?.comments,
    [loanDrilldown?.comments],
  );

  return (
    <TitledCard
      title={`Comments (${size(comments)})`}
      icon={<QuestionAnswerOutlined className="thin" />}
      headerEndContent={
        <Tooltip title="Add New Comment" disableInteractive>
          <IconButton
            size="small"
            onClick={() =>
              dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.COMMENTS))
            }
            sx={{ position: "absolute", right: 16, top: 16 }}
          >
            <AddRounded className="thin" />
          </IconButton>
        </Tooltip>
      }
      headerSx={{ pb: 1.5 }}
      cardSx={{
        display: "flex",
        flexBasis: width,
        flexShink: 0,
        flexGrow: 1,
        ...sx,
      }}
      innerSx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
      bodySx={{
        flexDirection: "column",
        flexGrow: 1,
        minHeight: "500px",
        display: "flex",
        justifyContent: "space-between",
      }}
      variant="h3"
      spt={!isEmpty(comments)}
      spl={!isEmpty(comments)}
      spr={!isEmpty(comments)}
      spb={!isEmpty(comments)}
    >
      {isEmpty(comments) ? (
        <EmptyCommentsContent />
      ) : (
        <>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              position: "relative",
              // borderTop: `1px solid #dde1e7`,
            }}
          >
            <Suspense fallback={<LoadingFallback />}>
              <EnhancedCommentItemRenderer
                loan={loanDrilldown}
                comments={comments}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  pt: 0,
                }}
              />
            </Suspense>
          </Box>
          <Flx end fw sx={{ p: 2 }}>
            <Button
              variant="text"
              onClick={() =>
                dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.COMMENTS))
              }
              endIcon={<EastRounded className="thin" />}
            >
              View All
            </Button>
          </Flx>
        </>
      )}
    </TitledCard>
  );
};

const EmptyCommentsContent = () => {
  const dispatch = useDispatch();

  return (
    <Flx column gap={2} center ac sx={{ height: "100%" }}>
      <SpeakerNotesOffRounded
        sx={{ fontSize: "24px", color: grey[400] }}
        className="thin"
      />
      <Txt color={grey[600]}>No comments added</Txt>
      <Button
        onClick={() => {
          dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.COMMENTS));
        }}
        endIcon={<AddRounded className="thin" />}
      >
        Add Comment
      </Button>
    </Flx>
  );
};

SummaryTabCommentsCard.propTypes = {
  baseUrl: PropTypes.string.isRequired,
};

export default SummaryTabCommentsCard;
